import { type JSX } from 'react';

import { Text } from '@videoblocks/design-system';

import { PRIVACY_POLICY_URL } from '../../_utils/constants';

/**
 * AI disclaimer shown beneath the composer across the conversational search
 * experience. "View policy" links out to the legal disclosure in a new tab.
 */
export function AiDisclosure(): JSX.Element {
    return (
        <Text fontFamily="inter" fontSize="xs" fontWeight="regular" className="mt-2 text-center text-gray-500">
            Chat powered by AI, can make mistakes.{' '}
            <a
                href={PRIVACY_POLICY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-gray-700"
            >
                View policy
            </a>
        </Text>
    );
}
